import setCurrentPage from "src/Utils/setCurrentPage";
import ConversationEffect from "src/Animations/ConversationEffect";

export const DATA_NOT_DEMO_TCA_2 = {
  title: "Streamline network service upgrades \nand capacity expansion",
  subtitle: "Network operation team",
  text: "Strategic scaling: plan and expand network functions for\n increased capacity to meet growing demands. Effortlessly\n upgrade network functions to the latest versions.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_314"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => {
      setCurrentPage("ILO_312");
    },
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Demo_bg.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ILO/TCA/TCA_NOT_Demo_2_1.png",
          imageStyle: { position: "absolute", top: "0", right: "0" },
        },
        {
          image: "ILO/TCA/TCA_NOT_Demo_2_2.png",
          imageStyle: { position: "absolute", top: "0", right: "0" },
        },
      ]}
      conversationStyle={{ width: "auto" }}
      pageNumber={"ILO_313"}
    />
  ),
};
